import React from "react";
import classnames from "classnames";
import Icon from "basic-elements/Icon";
import addPV from "utils/add-pv.js";
import styles from "./LanguageMenu.module.scss";

import languageMenuArray from "./LanguageMenuData.json";
import multipleSiteEnum from "constants/multipleSiteEnum.js";

const LanguageMenu = ({ siteId, isHomepage }) => (
  <div className={styles.languageMenu}>
    {languageMenuArray[siteId].map((i, idx) => {
      if (isHomepage) {
        return (
          <a
            key={i.name}
            href={multipleSiteEnum[idx + 1] === "en" ? "/" : "/" + multipleSiteEnum[idx + 1]}
            className={classnames(
              styles.languageMenu__link,
              siteId === idx + 1 ? styles.active : null
            )}
            onClick={e =>
              addPV(e, "trackEvent", {
                category: "homePage-userSetting",
                action: "userSetting_click",
                label: `language|${multipleSiteEnum[idx + 1]}`,
                path: multipleSiteEnum[idx + 1] === "en" ? "/" : "/" + multipleSiteEnum[idx + 1],
                openInNewTab: false
              })
            }
          >
            <strong className={styles.languageMenu__title}>{i.title}</strong>
            <span className={styles.languageMenu__name}>({i.name})</span>
            {siteId === idx + 1 && <Icon name="tick" className={styles.languageMenu__activeIcon} />}
          </a>
        );
      }
      return (
        <a
          key={i.name}
          href={multipleSiteEnum[idx + 1] === "en" ? "/" : "/" + multipleSiteEnum[idx + 1]}
          className={classnames(
            styles.languageMenu__link,
            siteId === idx + 1 ? styles.active : null
          )}
        >
          <strong className={styles.languageMenu__title}>{i.title}</strong>
          <span className={styles.languageMenu__name}>({i.name})</span>
          {siteId === idx + 1 && <Icon name="tick" className={styles.languageMenu__activeIcon} />}
        </a>
      );
    })}
  </div>
);

export default LanguageMenu;
